module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPgAAAD4AQAAAADpqhamAAABDklEQVRYheWVYQ5CMQyCuf+la1yBbjHxAHQm77l+9Q8BRP0/iOfoc1b7zceZLuDWiRPOqc4Cbp1aolZK0zW8ffHkYhenR5iPRZz54JfZrx0caoTnM9Nw7kQcZQ6YmCzg4BBTjawKLOFTkH0tVQSdEs6tEf3wKreAl23R0kAWQS3gagG1xcSlDZPO+ypDgD9wXOK5HcE9KCDcyOccmXVZOB/hnKJQlWtZDgnnrxkujZiedN62gLwyN1oknT8yMB3XLJ5/ZXBDyhnzRxHPdTBr3PU1msPA1uCtdnD7pDUqeoMVsYCPHu0K52P6YQEvPlQKgHTbwQfTG56m89GhI1J3RPK5+pHykP/2Zyj/f9L5BzrOiFlbV+CbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-code.png
// module id = 2132
// module chunks = 115